import { cmToPt } from '../../core/utils/math';
import type { TemplateProfile } from '../types';
import baseThumbnail from '../../../assets/temp-thumbnails/temp-thumbnail-1.jpg';

const TOTAL_WIDTH_CM = 18.40;
const SEPARATOR_CM = 0.40;
const DOUBLE_COL_CM = 9.0; // 9.0 + 0.40 + 9.0 = 18.40 cm exactly

/** Base template profile translated from legacy constants. */
export const baseProfile: TemplateProfile = {
  id: 'base',
  name: 'Base Template',
  version: '1.0',
  templateSourceKey: 'base_template-1',
  thumbnail: baseThumbnail,
  colorPalette: {
    exhibitLabel: '000000',
    exhibitDesc: '000000',
    sourceText: '000000',
    graphHint: '000000',
    graphBorder: undefined,
  },
  typography: {
    fontFamily: 'Arial MT',
    sourceFontSize: 7,
    graphHintSize: 9.5,
    headerFontSize: 9.5,
  },
  layouts: {
    full: {
      type: 'full',
      colWidth: cmToPt(TOTAL_WIDTH_CM),
      row1Height: cmToPt(0.49),
      row2Height: cmToPt(6.00),   // Full width graph: 6 cm height × 18.4 cm width
      row3Height: cmToPt(0.49),
    },
    half: {
      type: 'half',
      colWidth: cmToPt(DOUBLE_COL_CM),
      sepWidth: undefined,
      row1Height: cmToPt(0.49),
      row2Height: cmToPt(4.00),
      row3Height: cmToPt(0.56),
    },
    double: {
      type: 'double',
      colWidth: cmToPt(DOUBLE_COL_CM),
      sepWidth: cmToPt(SEPARATOR_CM),
      row1Height: cmToPt(0.49),
      row2Height: cmToPt(4.00),   // Double half-width graph: 4 cm height, each col = 9.0 cm (÷2 of 18.4 cm)
      row3Height: cmToPt(0.56),
    },
    'double-table': {
      type: 'double-table',
      colWidth: cmToPt(DOUBLE_COL_CM),
      sepWidth: cmToPt(SEPARATOR_CM),
      row1Height: cmToPt(0.49),
      row2Height: cmToPt(4.4),
      row3Height: cmToPt(0.56),
    },
    'table-graph': {
      type: 'table-graph',
      colWidth: cmToPt(DOUBLE_COL_CM),
      sepWidth: cmToPt(SEPARATOR_CM),
      row1Height: cmToPt(0.49),
      row2Height: cmToPt(4.4),
      row3Height: cmToPt(0.56),
    },
    'half-with-text': {
      type: 'half-with-text',
      colWidth: cmToPt(DOUBLE_COL_CM),
      sepWidth: cmToPt(SEPARATOR_CM),
      row1Height: cmToPt(0.49),
      row2Height: cmToPt(4.4),
      row3Height: cmToPt(0.56),
    },
    'first-page': {
      type: 'first-page',
      colWidth: cmToPt(13.76),
      row1Height: cmToPt(0.49),
      row2Height: cmToPt(4.86),
      row3Height: cmToPt(0.49),
    },
  },
  supportedLayoutTypes: ['full', 'half', 'double', 'double-table', 'table-graph', 'half-with-text', 'first-page'],

  // ── Table Box layout ──────────────────────────────────────────────────────
  // Full-width table: matches layouts.full.colWidth (18.4 cm) = same as Text Full
  tableLayout: {
    totalWidth:  cmToPt(TOTAL_WIDTH_CM),  // 521 pt — matches Text Full width
    leftIndent:  undefined,
    row1Height:  cmToPt(0.49),
    row2Height:  cmToPt(2.00),
    row3Height:  cmToPt(0.49),
  },
} satisfies TemplateProfile;
